import { gql } from '@apollo/client'

const RETRY_MENU_TITLE_LABELS_AND_INGREDIENTS_MUTATION = gql`
  mutation retryMenuTitleLabelsAndIngredients($id: ID!) {
    retryMenuTitleLabelsAndIngredients(id: $id)
  }
`

export default RETRY_MENU_TITLE_LABELS_AND_INGREDIENTS_MUTATION
